/* osyn-giveaway.js — page du jeu concours (section osyn-giveaway) ----------------------------------------------------
 * Statut : jours restants jusqu'à la fin des participations (data-fin, ISO avec décalage), comptés en jours du
 * calendrier de Paris : « Plus que [n] jours », la veille, le dernier jour ; textes longs (héros) et courts (barre).
 * Date passée : statut « closes », boutons vers le compte (data-compte, data-bouton-clos), barre flottante retirée
 * (avant osyn-plateforme-achat.js, chargé après ce script).
 * Vidéo : la publication d'Instagram (blockquote officiel et embed.js) n'est chargée qu'au toucher du bouton de la
 * vignette ; le focus passe au cadre, qui remplace la vignette.
 * Vidéo d'accueil (data-giveaway-film) : la lecture sans le son est celle du navigateur (autoplay, jamais de play ni de
 * pause au JS tant que le son est coupé : règle iOS). « Activer le son » ou un toucher sur la vidéo : le son, depuis le
 * début la première fois. Avec le son : toucher = pause ou lecture ; hors de l'écran, pause, et reprise au retour.
 * -------------------------------------------------------------------------- */
(function () {
  'use strict';
  if (window.OsynGiveaway) return;   // l'éditeur ré-exécute les scripts d'une section rechargée
  window.OsynGiveaway = true;

  var JOUR = 86400000;
  var calendrier = null;
  try {
    calendrier = new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Paris', year: 'numeric', month: '2-digit', day: '2-digit' });
  } catch (e) { /* sans fuseau : le statut reste la date en clair */ }

  function jourParis(date) {
    return Date.parse(calendrier.format(date) + 'T00:00:00Z');
  }

  function ecrire(racine, selecteur, texte) {
    if (!texte) return;
    racine.querySelectorAll(selecteur).forEach(function (el) { el.textContent = texte; });
  }

  function statut(racine) {
    var d = racine.dataset;
    var fin = Date.parse(d.fin);
    if (isNaN(fin) || !calendrier) return;
    var maintenant = new Date();
    if (maintenant.getTime() > fin) {
      ecrire(racine, '[data-giveaway-statut]', d.statutClos);
      if (d.compte) racine.querySelectorAll('[data-giveaway-cta]').forEach(function (lien) { lien.href = d.compte; });
      ecrire(racine, '[data-giveaway-cta-libelle]', d.boutonClos);
      var barre = racine.querySelector('[data-giveaway-barre]');
      if (barre) barre.remove();
      return;
    }
    var n = Math.round((jourParis(new Date(fin)) - jourParis(maintenant)) / JOUR);
    ecrire(racine, '[data-giveaway-statut]', n >= 2 ? (d.statutJours || '').replace('[n]', n) : n === 1 ? d.statutDemain : d.statutJour);
    ecrire(racine, '[data-giveaway-statut-court]', n >= 2 ? (d.barreJours || '').replace('[n]', n) : n === 1 ? d.barreDemain : d.barreJour);
  }

  function video(cadre) {
    var bouton = cadre.querySelector('[data-giveaway-video-lire]');
    var publication = cadre.dataset.publication;
    if (!bouton || !publication) return;
    bouton.addEventListener('click', function () {
      var bloc = document.createElement('blockquote');
      bloc.className = 'instagram-media';
      bloc.setAttribute('data-instgrm-permalink', publication);
      bloc.setAttribute('data-instgrm-version', '14');
      var lien = document.createElement('a');
      lien.href = publication;
      lien.textContent = cadre.dataset.lien || publication;
      bloc.appendChild(lien);
      cadre.classList.add('est-charge');
      cadre.replaceChildren(bloc);
      cadre.focus({ preventScroll: true });
      if (window.instgrm && window.instgrm.Embeds) {
        window.instgrm.Embeds.process();
        return;
      }
      if (document.querySelector('script[data-giveaway-embed]')) return;
      var script = document.createElement('script');
      script.src = 'https://www.instagram.com/embed.js';
      script.async = true;
      script.setAttribute('data-giveaway-embed', '');
      document.body.appendChild(script);
    });
  }

  function film(cadre) {
    var v = cadre.querySelector('video');
    var son = cadre.querySelector('[data-giveaway-film-son]');
    var lecture = cadre.querySelector('[data-giveaway-film-lecture]');
    if (!v || !son || !lecture) return;
    var d = cadre.dataset;
    var aJoue = false, ecoute = false, pauseAuto = false;

    function lancer() {
      var promesse = v.play();
      if (promesse && promesse.catch) promesse.catch(function () {});
    }
    function etat() {
      var arret = v.paused || v.ended;
      cadre.dataset.lecture = arret ? 'non' : 'oui';
      cadre.dataset.son = v.muted ? 'non' : 'oui';
      lecture.setAttribute('aria-label', arret ? d.lire : d.pause);
      if (v.muted) son.removeAttribute('aria-label');
      else son.setAttribute('aria-label', d.couper);
    }
    function avecSon() {
      if (!ecoute) { ecoute = true; v.loop = false; v.currentTime = 0; }
      v.muted = false;
      lancer();
    }

    son.addEventListener('click', function () {
      if (v.muted) avecSon();
      else v.muted = true;
    });
    lecture.addEventListener('click', function () {
      if (!v.paused && !v.ended) { v.pause(); return; }
      if (!aJoue && !ecoute) { avecSon(); return; }   // lecture bloquée à l'arrivée : le premier toucher lance avec le son
      if (v.ended) v.currentTime = 0;
      lancer();
    });
    v.addEventListener('click', function () {
      if (v.muted) { avecSon(); return; }
      if (v.paused || v.ended) {
        if (v.ended) v.currentTime = 0;
        lancer();
      } else {
        v.pause();
      }
    });
    ['play', 'pause', 'ended', 'volumechange'].forEach(function (type) { v.addEventListener(type, etat); });
    v.addEventListener('play', function () { pauseAuto = false; });
    v.addEventListener('playing', function () { aJoue = true; etat(); });
    /* Le HTML part de « en lecture » (pas de grand bouton qui clignote à l'arrivée) : sans lecture au bout de 2,5 s
       (économie d'énergie d'iOS, réseau lent), le grand bouton apparaît. */
    setTimeout(function () { if (!aJoue) etat(); }, 2500);

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entrees) {
        var e = entrees[entrees.length - 1];
        if (v.muted) return;   // sans le son, le navigateur suspend et reprend seul la lecture hors de l'écran
        if (e.intersectionRatio < 0.2) {
          if (!v.paused && !v.ended) { pauseAuto = true; v.pause(); }
        } else if (e.intersectionRatio >= 0.6 && pauseAuto) {
          lancer();
        }
      }, { threshold: [0, 0.2, 0.6] }).observe(cadre);
    }
  }

  function demarrer(portee) {
    portee.querySelectorAll('[data-osyn-giveaway]').forEach(function (racine) {
      if (racine._osynGiveaway) return;
      racine._osynGiveaway = true;
      statut(racine);
      racine.querySelectorAll('[data-giveaway-video]').forEach(video);
      racine.querySelectorAll('[data-giveaway-film]').forEach(film);
    });
  }

  demarrer(document);
  document.addEventListener('shopify:section:load', function (e) { demarrer(e.target); });
})();
